import { RootState } from "../../reducers";
import { useSelector, useDispatch } from "react-redux";
import { SelectorTitle, SelectorName, SelectorInputOption } from "../../styles/SelectorStyles";
import { sendAnalyticsEvent } from "../../utils/sendAnalyticMessages";
import { convertNameForOrderBy } from "../../utils";
const { orderBy } = require("lodash");

interface DataItem {
  type: string;
  name: string;
}

interface PillSelectorProps {
  title: string;
  data: DataItem[];
}

function PillSelector({ title, data }: PillSelectorProps): JSX.Element {
  const filterStore = useSelector((state: RootState) => state.filter);
  const dispatch = useDispatch();

  const parentURL = document.referrer
    ? document.referrer
    : window.location.ancestorOrigins?.[0];

  const selectType = (title: string): string | null => {
    switch (title) {
      case 'Calculate Stats From':
        return 'SET_STATS_FILTER';
      case 'Order By':
        return 'SET_GAMES_FILTER';
      default:
        return null;
    }
  }

  const selectEvent = (): string | null => {
    switch (title) {
      case 'Calculate Stats From':
        return 'smart_picks_stats_select';
      case 'Order By':
        return 'smart_picks_orderby_select';
      default:
        return null;
    }
  }

  const selectCheck = (type: string) => {
    switch (title) {
      case 'Calculate Stats From':
        return filterStore.statsFilter === type;
      case 'Order By':
        return filterStore.gamesFilter === type;
      default:
        return false;
    }
  }

  const getData = () => {
    const customOrder = ["stats-desc", "stats-asc", "odds-desc", "odds-asc", "kickoff"];
    switch (title) {
      case 'Order By':
        return orderBy(data, (item: DataItem) => customOrder.indexOf(item.type));
      default:
        return data;
    }
  }

  return (
    <>
      <SelectorTitle>
        {title}
      </SelectorTitle>
      {
        getData().map((i: DataItem) => (
          <SelectorInputOption key={i.type} onClick={() => {
            dispatch({
              type: selectType(title),
              payload: i.type,
            });
            dispatch({
              type: "SET_SELECTED_FILTER",
              payload: '',
            });
            sendAnalyticsEvent(
              {
                event: selectEvent(),
                selection: i.type,
              },
              parentURL
            );
          }}>
            <SelectorName>{convertNameForOrderBy(i.type, i.name)}</SelectorName>
            <div>
              <input
                readOnly
                type="radio"
                id={i.type}
                name={title}
                value={i.type}
                checked={selectCheck(i.type)}
              />
            </div>
          </SelectorInputOption>
        ))
      }
    </>
  );
}

export default PillSelector;
